import { isiOS } from './isiOS';

export const PDF_MIN_ZOOM = 0.25;
export const PDF_MAX_ZOOM = 4;
export const PDF_ZOOM_STEP = 0.25;

const preparePdfScaleSteps = () => {
  const steps = [];
  for (let i = PDF_MIN_ZOOM; i <= PDF_MAX_ZOOM; i += PDF_ZOOM_STEP) {
    steps.push(i);
  }
  return steps;
};

export const pdfScaleSteps = preparePdfScaleSteps();

// Maximum canvas size in total pixels
// Limits for browsers can be found here: https://jhildenbiddle.github.io/canvas-size/#/
// We can set it to higher value, (even ~124_000_000), but such a big canvas will be very slow to render
// Let's try with 64M pixels for now and increase it if needed
const MAX_CANVAS_PIXELS = 64_000_000;

// iOS can not display canvas larger than 16777216 pixels (Apple, really??)
// https://pqina.nl/blog/canvas-area-exceeds-the-maximum-limit/
const MAX_IOS_CANVAS_PIXELS = 10_000_000;

export const getMaxCanvasPixels = () => (isiOS() ? MAX_IOS_CANVAS_PIXELS : MAX_CANVAS_PIXELS);
